import React from 'react';
import Display from '../parts/display';
import _delay from 'lodash/delay';
import {TimelineLite} from 'gsap';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as siteActions from '../../actions/siteActions';
import {Link} from 'react-router';

import Feedback from '../feedback';

class Menu extends React.Component {
    constructor() {
        super();
        this.state = {
            visible: true,
            open: false,
            navBar: false,
            year: new Date().getFullYear()
        }

        this.open = this.open.bind(this);
        this.animateOut = this.animateOut.bind(this);
        this.logout = this.logout.bind(this);
        this.tl = new TimelineLite();
    }
    showHideMenu(show){
        this.setState({
            visible: show
        });
    }
    showNavBar(show){
        this.setState({
            navBar: show
        });
    }
    open(){
        if(this.state.open){
            this.setState({
                open: false
            });
        }else{
            this.setState({
                open: true
            });
        }
    }
    logout(){
        this.props.actions.userLogout();
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.site.pageChange !== this.props.site.pageChange){
            if(nextProps.site.pageChange.next == '/'){
                this.animateOut(nextProps.site.pageChange.callback);
            }
            this.setState({
                open: false
            });
        }
    }
    animateOut(callback){
        let _this = this;
        this.tl.to(this.refs.logo, .5, {opacity: 0})
            .to(this.refs.navBar, .5, {height: '100vh'})

            .call(function(){
                callback();
                // _this.props.actions.endTransition(true);

                _delay(function () {
                    _this.props.actions.showNavBar(false);
                },100);
            });
    }
    componentWillMount() {
        if(!this.props.site.aboutPage){
            this.props.actions.loadAboutPage();
        }
    }
    render() {
        let contact = false;
        if(this.props.site.pageChange){
            if(this.props.site.pageChange.next === '/start-project') contact = true;
        }
        return (
            <div>
                <div className={this.props.site.menuVisible? 'visible menu-btn':'menu-btn'} ref="menuBtn" onClick={this.open}>
                    <span>{this.state.open ? 'Close' : 'Menu'}</span>
                    <div className={"hamburger " + (this.state.open ? 'open' : '')}>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <Display if={this.props.site.navBarVisible}>
                    <div className="nav-bar" ref="navBar">
                        <Link to="/" className="pull-left">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 230.11 46.31" className="site-logo animated fadeIn">
                                <g ref="logo">
                                    <g>
                                        <path d="M67.68,45.79H61.59L39.92,11.41l-.19.06V45.79H33.65V.78h6.09L61.41,35.13l.19-.06V.78h6.09Z" fill="#262729"/>
                                        <path d="M80.62,45.79V.78H94.78q8.81,0,14.17,5.42t5.36,14v6.15q0,8.63-5.36,14t-14.17,5.4ZM86.71,5.57V41h8.07a12.42,12.42,0,0,0,9.85-4.11,15.42,15.42,0,0,0,3.6-10.54V20.16a15.33,15.33,0,0,0-3.6-10.48,12.41,12.41,0,0,0-9.85-4.11Z" fill="#262729"/>
                                        <path d="M183.06,39.6a14.49,14.49,0,0,1-5.58,4.61,22,22,0,0,1-10.31,2.1,17.36,17.36,0,0,1-12.89-5.16q-5.1-5.16-5.1-13.36V18.52q0-8.19,4.92-13.36A16.72,16.72,0,0,1,166.76,0q7.51,0,11.87,4a12.85,12.85,0,0,1,4.24,10.19l-.06.19H177a9.44,9.44,0,0,0-2.66-6.85q-2.66-2.74-7.54-2.73a10.21,10.21,0,0,0-8.32,3.86,15,15,0,0,0-3.15,9.8v9.33a14.6,14.6,0,0,0,3.34,9.88,10.76,10.76,0,0,0,8.53,3.88,15.86,15.86,0,0,0,6.32-1A9.13,9.13,0,0,0,177,38.06V27.91h-10.2V23.15h16.29Z" fill="#262729"/>
                                        <path d="M230.11,27.17A19.21,19.21,0,0,1,225,40.87a17.4,17.4,0,0,1-13.28,5.44,16.49,16.49,0,0,1-12.81-5.44A19.62,19.62,0,0,1,194,27.17v-8a19.69,19.69,0,0,1,4.93-13.7A16.45,16.45,0,0,1,211.72,0,17.37,17.37,0,0,1,225,5.46a19.26,19.26,0,0,1,5.12,13.71ZM224,19.1A15.18,15.18,0,0,0,220.68,9a11.13,11.13,0,0,0-9-4,10.31,10.31,0,0,0-8.49,4,15.72,15.72,0,0,0-3.17,10.14v8.07a15.81,15.81,0,0,0,3.17,10.2,10.31,10.31,0,0,0,8.49,4,11.13,11.13,0,0,0,9-3.94A15.31,15.31,0,0,0,224,27.17Z" fill="#262729"/>
                                        <polygon points="6.41 45.79 22.73 0.78 16.32 0.78 0 45.79 6.41 45.79" fill="#262729"/>
                                        <polygon points="126.79 45.79 143.11 0.78 136.7 0.78 120.38 45.79 126.79 45.79" fill="#262729"/>
                                    </g>
                                </g>
                            </svg>
                        </Link>
                        <Display if={this.props.site.user}><p className="logout-link pull-right animated fadeIn" onClick={this.logout}>Logout</p></Display>
                    </div>
                </Display>
                <div className={"main-nav " + (this.state.open ? 'open' : '')}>
                    <div className="menu-content">
                        <ul>
                            <li><Link to="/" activeClassName="active" onlyActiveOnIndex><i>/</i>home</Link></li>
                            <li><Link to="/services" activeClassName="active"><i>/</i>services</Link></li>
                            <li><Link to="/portfolio" activeClassName="active"><i>/</i>portfolio</Link></li>
                            <li><Link to="/about" activeClassName="active"><i>/</i>about</Link></li>
                            <li><Link to="/blog" activeClassName="active"><i>/</i>blog</Link></li>
                            <li><Link to="/contact" activeClassName="active"><i>/</i>contact</Link></li>
                        </ul>
                        <div className="phone-email">
                            <p><a href="tel: +441912092100"><i className="fa fa-phone"></i> 0191 209 2100</a></p>
                            <p><a href="mailto: info@indigomultimedia.com"><i className="fa fa-envelope-o"></i> info@indigomultimedia.com</a></p>
                        </div>
                        <div className="social-links">
                            <a href="https://twitter.com/indigo_digital" target="_blank"><i className="fa fa-twitter"></i></a>
                            <a href="https://www.linkedin.com/company/indigo-multimedia?trk=biz-companies-cym" target="_blank"><i className="fa fa-linkedin"></i></a>

                            <Link to="/privacy" className="terms-link">Privacy</Link>
                            <Link to="/terms" className="terms-link">T&C's</Link>
                            <a href="#" className="terms-link">&copy; Indigo {this.state.year}</a>
                        </div>
                    </div>
                </div>
                <Display if={!this.props.location.state && this.props.location.pathname !== '/' && !this.props.site.sentStartProject}>
                    <Link to={{
                        pathname: '/start-project',
                        query: {
                            type: this.props.site.selectedService.slug
                        },
                        state: { modal: true, returnTo: this.props.location.pathname}
                    }} className={this.props.site.navBarVisible && !contact ? "start-project-btn animated fadeIn" : "start-project-btn animated fadeOut"}>
                        <span className="dash">/</span> Start your<span dangerouslySetInnerHTML={{__html: this.props.site.selectedService? ' '+ this.props.site.selectedService.name: ''}}></span> Project

                    </Link>
                </Display>
            </div>
        );
    }
}
function mapStateToProps(state, ownProps) {
    return {
        site: state.site
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(siteActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu);


/** WEBPACK FOOTER **
 ** ./src/js/components/common/menu.js
 **/